<template>
<div class="fakeBlog">
  <content-loader
    :height="250"
    :width="400"
    :speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="16" y="35" rx="4" ry="4" width="350" height="12" /> 
    <rect x="16" y="60" rx="3" ry="3" width="85" height="6" /> 
    <rect x="0" y="115" rx="3" ry="3" width="400" height="1" /> 
    <rect x="16" y="135" rx="3" ry="3" width="380" height="6" /> 
    <rect x="16" y="155" rx="3" ry="3" width="380" height="6" /> 
    <rect x="16" y="175" rx="3" ry="3" width="350" height="6" /> 
    <rect x="16" y="200" rx="3" ry="3" width="380" height="90" />
  </content-loader>
</div>
</template>
    
<script>
  import { ContentLoader } from "vue-content-loader"

  export default {
    components: {
      ContentLoader
    }
  }
</script>

<style scoped>
    .fakeBlog {
        background-color: white;
    }
</style>
